import axios from "@/store/axios";
import {V1API} from "@/http/APIPath";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";
import dataMagic, {decode, encode} from "@/store/dataMagic"
import ToastificationContent from "@core/components/toastification/ToastificationContent";

const keyList = {
    organizationUpdate : 'ORGANIZATION_UPDATE',
    organizationDelete : 'ORGANIZATION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        organization: [],
        organizationLoading: false,
        organizationError: false,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_ORGANIZATION (state, organization) {
            state.organization = organization;
        },

        ORGANIZATION_LOADING (state, loading) {
            state.organizationLoading = loading;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        ORGANIZATION_ERROR(state, error) {
            state.submitError = error;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        async updateOrganization({commit, state, dispatch}, payload) {
            let response = '';
            await performNetworkCall(
                commit,
                keyList.countryUpdate,
                async () => {
                    let payloadData={ 
                        name: payload.name
                    }
                    let magic=encode(payloadData)
                    response = await axios.post(V1API.update_organization+"/"+payload.id,magic.encodedPayload,magic.config).then(result => {
                        let data=decode(result.data)
                        return data.message
                    })

                    dispatch('fetchOrganization');

                }
            )
            return response
        },

        async deleteOrganization({commit, state, dispatch}, payload) {
            let response='';
            await performNetworkCall(
                commit,
                keyList.countryDelete,
                async () => {

                    response = await axios.delete(V1API.delete_organization + payload).then(result=>{
                        let data=decode(result.data)

                        return data.message

                    });
                    dispatch('fetchOrganization');
                }
            )

            return response
        },

        async fetchOrganization ({ commit },payload) {
            commit('ORGANIZATION_LOADING', true);
            commit('ORGANIZATION_ERROR', false);
            try{

                let result = await axios.get(V1API.fetch_organization);
                let response=decode(result.data.data)
                commit('SET_ORGANIZATION', response); 

            }catch(error) {

                commit('ORGANIZATION_ERROR', true);

            }
            commit('ORGANIZATION_LOADING', false);
        },

        async createOrganization({commit,dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let magic=encode(payload)
                let response = await axios.post(V1API.create_organization,magic.encodedPayload,magic.config).then(result=>{
                    let data=decode(result.data)

                    return data.message

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchOrganization')
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },
    },
    
    getters: {}
}